import { Box, IconButton, Stack, Tab, Tabs } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

type BaseTabItem = {
    id: string;
    name?: string;
};

type TableTabsProps<T extends Record<string, unknown>> = {
    id: string;
    handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
    handleAdd?: () => void;
    tabData: T[] | undefined;
    children?: React.ReactNode;
    active: boolean;
    renderAdd?: boolean;
};

const TableTabs = <T extends BaseTabItem>({
    id,
    children,
    handleAdd,
    handleTabChange,
    tabData = [],
    active,
    renderAdd = true,
}: TableTabsProps<T>) => {
    const sortedTabData = [...tabData].sort((a, b) => a.name!.localeCompare(b.name!));
    return (
        <Box>
            <Stack direction="row" alignItems="center" sx={{ width: '100%' }}>
                <Tabs
                    value={id}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{ style: { display: 'none' } }}
                    sx={{
                        flexGrow: 1,
                        width: '50%',
                        ml: 3,
                    }}
                >
                    {sortedTabData.map((data) => (
                        <Tab label={data.name} key={data.id} value={data.id} />
                    ))}
                </Tabs>
                {renderAdd && (
                    <IconButton onClick={handleAdd} sx={{ mr: 5 }}>
                        <AddIcon />
                    </IconButton>
                )}
            </Stack>
            {active && children}
        </Box>
    );
};

export default TableTabs;
